module.exports = __webpack_public_path__ + "static/media/icon-backup-auto.d2f068f0.svg";